var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIsoColorBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 154.32 159",
    style: {
      enableBackground: "new 0 0 154.32 159"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#21AA70;}\n\t.st1{fill:#00859B;}\n\t.st2{fill:#F76D00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.16,15.42c1.99,0,3.98,0.51,5.76,1.53l45.84,26.28c3.59,2.06,5.82,5.9,5.82,10.04v52.46c0,4.14-2.23,7.99-5.82,10.04 l-45.84,26.28c-3.55,2.04-7.96,2.04-11.51,0l-45.84-26.28c-3.59-2.05-5.82-5.9-5.82-10.04V53.27c0-4.14,2.23-7.98,5.82-10.04 L71.4,16.95C73.18,15.93,75.17,15.42,77.16,15.42 M77.16,136.58c0.79,0,1.57-0.2,2.27-0.6l45.84-26.28 c1.42-0.81,2.3-2.33,2.3-3.97V53.27c0-1.64-0.88-3.15-2.3-3.97L79.43,23.02c-1.4-0.8-3.15-0.8-4.55,0L29.05,49.3 c-1.42,0.81-2.3,2.33-2.3,3.97v52.46c0,1.64,0.88,3.16,2.3,3.97l45.84,26.28C75.59,136.38,76.37,136.58,77.16,136.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.27,108.52c-3.95,0-7.15-3.2-7.15-7.15c0-19.45,10.17-24.09,17.6-28.16c6.56-3.59,10.17-4.64,10.17-15.62 c0-3.95,3.2-7.15,7.15-7.15c3.95,0,7.15,3.2,7.15,7.15c0,19.45-10.17,24.09-17.6,28.16c-6.56,3.59-10.18,4.64-10.18,15.62 C70.42,105.32,67.22,108.52,63.27,108.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.27,72.14c-3.95,0-7.15-3.2-7.15-7.15v-7.41c0-3.95,3.2-7.15,7.15-7.15c3.95,0,7.15,3.2,7.15,7.15V65 C70.42,68.94,67.22,72.14,63.27,72.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.05,108.16h-0.27c-3.95,0-7.15-3.2-7.15-7.15c0-3.95,3.2-7.15,7.15-7.15h0.27c3.95,0,7.15,3.2,7.15,7.15 C98.2,104.96,95,108.16,91.05,108.16"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIsoColorBlack);
export default __webpack_public_path__ + "static/media/logo-iso-color-black.3467f1ca107c93b6c8cca7cea0d5fe3a.svg";
export { ForwardRef as ReactComponent };